import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from './shared.module';
import { BbTableModule } from './bb-table.module';
import { PipesModule } from './pipes.module';

import { DirectivesModule } from './directives.module';

import { InteractivityEditorService } from '../components/shared/interactivity-editor/services/interactivity-editor.service';

import { InteractivityEditorModule } from '../components/shared/interactivity-editor/modules/interactivity-editor.module';
import { InteractivityTimelineDetailsComponent }
	from '../components/library/interactivity/interactivity-timeline-details.component';
import { DragSelectorComponent } from '../components/shared/interactivity-editor/components/stage/drag-selector.component';


@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		PipesModule,
		FormsModule,
		BbTableModule,
		DirectivesModule,
		InteractivityEditorModule
	],
	declarations: [
		InteractivityTimelineDetailsComponent,
		DragSelectorComponent
	],
	exports: [
		InteractivityTimelineDetailsComponent,
	],
	providers: [
		InteractivityEditorService
	]
})
export class InteractivityModule {
	/* nothing */
}
